import { useState } from 'react';
import { img } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';
import ContactModal from '@/components/feature/ContactModal';
export default function FranchiseHero() {
  const [showFranchiseModal, setShowFranchiseModal] = useState(false);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${img('readdy/8ccae5c9e3acdb8b0a1fb1d47b252066.png')})`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />

      <div className="relative z-10 w-full h-full flex flex-col px-6 md:px-10 pt-20 md:pt-24 pb-10">
        <div className="max-w-7xl mx-auto w-full flex-1 flex flex-col justify-center">
          <ScrollReveal variant="fade-right">
            <p className="text-brand-gold text-sm tracking-widest mb-4 font-medium">招商加盟</p>
            <h1 className="text-2xl md:text-3xl lg:text-5xl font-bold text-white leading-snug mb-5 max-w-2xl">
              携手麦杰集团，
              <br />
              共建健康纤体连锁事业
            </h1>
            <p className="text-white/60 text-xs md:text-sm leading-relaxed mb-8 max-w-md">
              十余年行业经验、多省市场覆盖、总部系统扶持。
              无论您是美容院经营者、健康行业创业者还是区域合伙人，
              麦杰集团为您提供可复制的成功模型。
            </p>
            <button
              onClick={() => setShowFranchiseModal(true)}
              className="inline-flex items-center gap-2 px-8 py-3 bg-brand-deep text-white text-sm font-medium rounded-full hover:bg-brand-dark transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              提交加盟申请
              <i className="ri-arrow-right-line" />
            </button>
          </ScrollReveal>
        </div>
      </div>

      <ContactModal
        open={showFranchiseModal}
        onClose={() => setShowFranchiseModal(false)}
        type="franchise"
      />
    </section>
  );
}